<template>
    <div>
        <portal to="breadcrumbs">
            <ul class="breadcrumb breadcrumb-transparent font-weight-bold p-0 my-2 font-size-sm">
                <slot/>
            </ul>
        </portal>
    </div>
</template>

<script>
export default {
}
</script>
